import { Fragment, ReactElement } from 'react';
import Breadcrumbs, { BreadcrumbItem } from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';
import ActionsList from './actions';

interface ResearchCivilUnionNotificationSharedProps {
  items?: BreadcrumbItem[];
  goBackUrl?: string;
  redirectUrl?: string;
}

const ResearchCivilUnionNotificationShared = ({
  goBackUrl,
  redirectUrl,
  items,
}: ResearchCivilUnionNotificationSharedProps): ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={items || []} />
      <PersonSearch
        pathname={redirectUrl}
        action={ActionsList}
        addedTitle="- Registrazione Unione Civile"
        goBackUrl={goBackUrl}
      />
    </Fragment>
  );
};

ResearchCivilUnionNotificationShared.displayName =
  'Research Civil Union Notifications Page component';

export default ResearchCivilUnionNotificationShared;
